import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QuestionInfoComponent } from './component/questionInfo.component';
import { QuestionInfoRoutingModule } from '../questionInfo/questionInfo.routing.module';
import { PipeModule } from 'src/app/shared/pipes/pipes.module';
import { QuestionInfoTextModule } from 'src/app/shared/components/questions-info-text/questionInfoText.module';
import { EquisLoadingModule } from '@tn-equis/core/components/loading';
import { EquisActionCardModule } from '@tn-equis/core/components/action-card';

@NgModule({
  declarations: [QuestionInfoComponent],
  imports: [
    CommonModule,
    QuestionInfoRoutingModule,
    EquisLoadingModule,
    EquisActionCardModule,
    PipeModule,
    QuestionInfoTextModule,
  ],
})
export class QuestionInfoModule {}
